import { render, staticRenderFns } from "./homeIcons.vue?vue&type=template&id=ba788c68&scoped=true&"
import script from "./homeIcons.vue?vue&type=script&lang=js&"
export * from "./homeIcons.vue?vue&type=script&lang=js&"
import style0 from "./homeIcons.vue?vue&type=style&index=0&id=ba788c68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba788c68",
  null
  
)

export default component.exports